export default "__VITE_ASSET__4c712c81__"